import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type SignatureWhiteProps = React.HTMLAttributes<HTMLDivElement> & {};

export const SignatureWhite: React.FC<SignatureWhiteProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/signature_white.svg"} alt="" />
    </div>
  );
}; 